module.exports = __webpack_public_path__ + "media/images/placeholder-65582a57bc8a7593774314b855b9a039.svg";